import type { Location } from "react-router-dom";

export interface SkillPagerState {
    currentIndex: number;
    total: number;
    hasSkillInList: boolean;
    canGoToPrevious: boolean;
    canGoToNext: boolean;
}

export const getSkillPagerState = ({
    skillIds,
    skillId,
    hasUnsavedChanges,
}: {
    skillIds: string[];
    skillId: string | null;
    hasUnsavedChanges: boolean;
}): SkillPagerState => {
    const index = skillId === null ? -1 : skillIds.indexOf(skillId);
    const hasSkillInList = index !== -1;
    const canPage = hasSkillInList && !hasUnsavedChanges;
    return {
        currentIndex: hasSkillInList ? index + 1 : 0,
        total: skillIds.length,
        hasSkillInList,
        canGoToPrevious: canPage && index > 0,
        canGoToNext: canPage && index < skillIds.length - 1,
    };
};

const isStringArray = (value: Location["state"]): value is string[] =>
    Array.isArray(value) && value.every((item) => typeof item === "string");

/** The list order handed over through location state; empty for a direct link. */
export const readSkillIdsFromState = (state: Location["state"]): string[] =>
    state !== null &&
    typeof state === "object" &&
    "skillIds" in state &&
    isStringArray(state.skillIds)
        ? state.skillIds
        : [];
